import MyCollapse from "../../components/MyCollapse";

const AboutUs06 = () => {
  const content = [
    {
      value: 1,
      title: "아기를 떠나 보내며",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 0 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/06-01.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                의료진은 아기를 살리기 위해 최선을 다하지만, CDH 아기의 약
                20-40%는 결국 생존하지 못하고 부모 곁을 떠나게 됩니다. 아기들이
                생존하지 못하는 가장 큰 이유는 폐나 심장이 엄마 뱃속에서 충분히
                성숙하지 못해 스스로 살아갈 준비가 되지 않았기 때문입니다. 또한,
                수술이나 중환자실 치료 중 발생하는 합병증과 같은 다른 요인들이
                사망 원인이 되기도 합니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac2-4">
            <h5>
              아기의 임종이 임박했다고 판단되면, 의료진은 부모님과 면담을
              갖습니다. 의료진은 지금까지 아기에게 시도한 치료와 현재 상태를
              자세히 설명하며, 추가로 시도할 수 있는 치료가 있는지, 아니면 이제
              아기를 편안히 보내야 할 때인지에 대한 의견을 드릴 것입니다. 아기를
              떠나보내야 하는 결정은 의료진과 부모 모두에게 고통스럽지만,
              중환자실에서 힘든 시간을 견뎌온 아기와 그 여정을 함께해온 부모님과
              가족을 위해 최선의 선택이 될 수 있습니다.
            </h5>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "아기와 이별을 준비하다.",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 0 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/06-02.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                아기가 중환자실 치료로 회복될 가능성이 없다고 판단되면,
                부모님에게는 아기와 마지막 순간을 함께할 기회를 드리게 됩니다.
                이 시간은 깊은 슬픔 속에서도 가족이 아기에게 사랑을 전하고, 그간
                함께한 시간을 간직할 소중한 기회가 됩니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac2-4">
            <h5>
              이별의 방식은 가족마다 다르지만, 부모님은 아기를 품에 안고 사랑을
              나누며 손을 잡거나 노래를 불러줄 수 있습니다. 의료진은 아기가
              부모님의 품에서 평온히 마지막을 맞이할 수 있도록 최대한 편안한
              환경을 제공하고, 부모님이 원할 경우 가족, 형제자매, 친척들이 작별
              인사를 나눌 수 있도록 도울 것입니다.
            </h5>
            <h5>
              아기에게 “사랑해,” “너는 항상 소중한 존재였어,” “영원히 기억할
              거야” 등의 말을 전하며, 손을 잡거나 안아주고 눈을 맞추는 행동을
              통해 부모의 깊은 사랑을 느끼게 해 줄 수 있습니다. 태교 시 자주
              들려준 음악이나 가족의 목소리 녹음을 아기에게 들려주는 것도 따뜻한
              추억을 남기는 방법입니다.
            </h5>
            <h5>
              추후 기억할 수 있도록 사진을 찍거나 발도장을 남기는 것도 부모님의
              마음속에 아기의 존재를 오래도록 간직하게 도와줍니다. 부모님이
              준비되었다고 느낄 때, 작은 예식이나 기도를 통해 아기를 평온히 떠나
              보내는 과정도 의미 있을 것입니다.
            </h5>
            <h5>
              우리나라 중환자실은 일반적으로 감염 방지 등의 이유로 방문객 제한
              정책을 가지고 있어 중환자실에 입원한 다른 환자와 보호자의 입장도
              함께 고려하여 요청 사항 수용 여부를 결정하게 됩니다.
            </h5>
          </div>
        </div>
      ),
    },
    {
      value: 3,
      title: "아기 별이 되다.",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 10 }}>
            <div className="top" style={{ marginBottom: 10 }}>
              <span>
                <img
                  src="/assets/img/icon/06-03.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <dl style={{ paddingLeft: 0, marginTop: 0 }}>
                <dt>01</dt>
                <dd>
                  <h2>아이의 마지막 순간</h2>
                  <p>
                    의료진은 아기의 사망을 확인하며 사망 일시를 포함한 임종
                    선언을 합니다. 임종 후에는 의료진이 아이가 몸에 가지고 있던
                    다양한 도관 (중심정맥관, 인공호흡기, 도뇨관 등)과 모니터
                    선을 떼게 됩니다. 또한 몸을 닦아주고 깨끗한 옷과 모자로 갈아
                    입힙니다. 이 과정이 끝나면 가족이 아기와 함께 있을 수 있는
                    시간을 마련해 드립니다. 가족과 병실 또는 중환자실에서의
                    시간이 종료되면 보통은 병원 직원과 함께 장례식장으로
                    옮겨지게 됩니다. 이후 장례지도사와 상의하여 이후 절차를
                    진행하게 됩니다.
                  </p>
                </dd>
              </dl>
            </div>
          </div>
          <div className="ac_text ac6-3">
            <dl>
              <dt>02</dt>
              <dd>
                <h2>장례 준비</h2>
                <p>
                  아기의 임종을 미리 준비하는 것은 매우 힘들고 마음 아픈
                  일입니다. 그러나 사전에 장례에 대한 구체적인 계획을 세운다면
                  임종과정에서 아이와의 시간에 좀 더 집중할 수 있게 됩니다. 갈아
                  입힐 옷을 미리 준비해두는 것도 좋습니다. 손수 가지고 오신 옷을
                  아기에게 입혀 주시려면 미리 의료진에게 전달해 주십시오. 옷은
                  조금 넉넉한 사이즈를 준비하는 것이 좋고 모자와 양말 속싸개를
                  함께 준비하는 것도 좋습니다.
                </p>
                <p>
                  간혹 아기의 빈소를 원하시지 않는 부모님도 계십니다. 하지만
                  아기의 빈소를 마련하는 것은 가족들과 함께 슬픔을 나누고 아기와
                  인사할 수 있는 시간을 좀 더 가지는 의미 있는 일이 될 수
                  있습니다. 입관 의식 시 아기의 인형, 가족의 편지나 사진 등을
                  넣어 줄 수 있으니 준비하셔도 좋습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>사별 돌봄 안내</h2>
                <p>
                  사랑하는 아이를 천국으로 보내는 아픔은 그 어떤 것에 비교할 수
                  없는 큰 상실입니다. 부모가 슬픔, 충격, 분노, 혼란 등 다양한
                  감정을 느끼는 것은 자연스러운 일입니다. 모든 감정은 소중하며
                  그 감정을 인정하고 받아들이는 것이 중요합니다. 이 과정에서
                  주변 사람들과 감정을 나누는 것도 큰 위로가 될 수 있습니다.
                  적절한 도움을 받으시는 것이 중요합니다. 필요하다면 전문가
                  상담을 통해 감정을 나누고 마음의 짐을 덜어내는 시간이
                  필요합니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>04</dt>
              <dd>
                <h2>기억하기와 추모</h2>
                <p>
                  사랑하는 아기를 기억하는 것은 슬픔 속에서도 큰 위로가 될 수
                  있습니다. 사진을 남기거나 추모의식을 통해 아기의 존재를
                  기억하는 시간이 필요할 수 있습니다. 이러한 과정은 상실을
                  수용하고 사랑을 기리는 중요한 단계입니다. 자녀의 탄생 과정을
                  정성스럽게 준비하듯 우리에게 기쁨과 행복을 선물해 준 자녀를 잘
                  보내 주는 과정 역시 매우 중요합니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco">
      <MyCollapse data={content} />

      <div className="ac_text">
        <div className="info_text">
          <p>
            신생아 집중 치료와 수술 기법의 발전에도 불구하고 여전히 많은 CDH
            아기들은 생존하지 못합니다. 하지만 아기들은 어떤 상황에서도 사랑을
            받을 권리가 있으며 아기가 잠깐이라도 가족의 일원이었던 것 만으로도
            큰 의미가 있습니다. 언젠가는 꼭 다시 만나게 될 아기를 위해 가족 모두
            아름다운 이별을 준비할 수 있도록 의료진은 최선을 다해 도와드릴
            것입니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs06;
